import type { DefaultAttributeValue } from '@source-components-react/types';
import { DEFAULT_BUTTON_PRESET } from './button-presets';
import {
  BUTTON_LABEL_ATTRIBUTE,
  BUTTON_PRESET_ATTRIBUTE,
  DEFAULT_BUTTON_LABEL,
} from './button-attributes';

/**
 * Seeds the button's own semantics only.
 *
 * No style attribute may be seeded here, and the omission is load-bearing
 * rather than an oversight. Defaults are merged into the column's attribute
 * bag before styles are computed, so a seeded `border-radius-3-resolutions`
 * would be present on every button and would override the preset's radius
 * forever — the preset would appear to have no effect on anything a default
 * happened to cover. Leaving the bag empty is what lets "unset means preset"
 * be true.
 */
export const defaultAttributeValues: DefaultAttributeValue[] = [
  {
    name: BUTTON_PRESET_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_BUTTON_PRESET,
    },
  },
  {
    name: BUTTON_LABEL_ATTRIBUTE,
    defaultValues: {
      all: DEFAULT_BUTTON_LABEL,
    },
  },
];
